import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M8 1C4.134 1 1 4.134 1 8s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7m0 2c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M9.289 6.818c.387-.393 1.02-.399 1.414-.011.364.358.396.925.094 1.32l-.083.094-2 2.033c-.362.368-.937.396-1.332.085l-.094-.085-2-2.033c-.387-.394-.381-1.027.013-1.414.363-.358.93-.38 1.32-.072l.094.083L8 8.127l1.288-1.309z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M12 2C6.477 2 2 6.478 2 12c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10 0-5.522-4.478-10-10-10m0 2c4.411 0 8 3.588 8 8s-3.589 8-8 8c-4.41 0-8-3.588-8-8s3.59-8 8-8"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M7.295 10.293c.36-.36.928-.388 1.32-.083l.094.083 3.292 3.293 3.294-3.293c.36-.36.928-.388 1.32-.083l.094.083c.36.361.389.928.084 1.32l-.084.095-4 4c-.361.36-.928.388-1.32.083l-.095-.083-3.999-4c-.39-.391-.39-1.024 0-1.415z"
        />
      </g>
    </svg>
  ),
};
